import { http } from '../utils/http'

// dataSource 查询
const searchAction = (params, page, size) => {
    const url = `/config/dataSourceConfigInfo/page`
    return http.post(url, params, page, size)
};

// dataSource 新增/修改
const addAction = (params) => {
    const url = `/config/dataSourceConfigInfo/save`
    return http.post(url, params)
};

// dataSource 获取详情
const getInfoAction = (id) => {
    const url = `/config/dataSourceConfigInfo/get/${id}`
    return http.post(url)
};

// dataSource 锁定
const lockAction = (params) => {
    const url = `/config/dataSourceConfigInfo/changeStatus`
    return http.post(url, params)
};

// dataSource 复制
const copyAction = (params) => {
    const url = `/config/dataSourceConfigInfo/copy`
    return http.post(url, params)
};

// 导入
const importAction = (params) => {
    const url = `/config/dataSourceConfigInfo/import`
    return http.post(url, params)
};

// 导出
const exportAction = (params) => {
    const url = `/config/dataSourceConfigInfo/export`
    return http.post(url, params)
};

// customer
const customerAction = () => {
    const url = `/config/customer/list`
    return http.post(url)
};

// groovy
const groovyAction = (client) => {
    const url = `/config/groovyScript/clientList/${client}`
    return http.post(url)
};

// version
const versionAction = (id) => {
    const url = `/config/groovyScript/get/${id}`
    return http.post(url)
};

// text DB
const textDB = (params) => {
    const url = `/api/v1/file/jdbc/ping`
    return http.post(url, params)
};

// text SFTP
const textSFTP = (params) => {
    const url = `/api/v1/file/sftp/ping`
    return http.post(url, params)
};

// text Blob
const textBlob = (params) => {
    const url = `/api/v1/file/blob/ping`
    return http.post(url, params)
};

const getKeyVaultNameList = () => {
    const url = `/config/keyVault/getKeyVaultNameAndId`
    return http.post(url)
};

const getNameAndWordByKV = (id) => {
    const url = `/config/keyVault/getNameAndWordByKV/${id}`
    return http.post(url)
};

export default {
    searchAction,
    addAction,
    lockAction,
    copyAction,
    importAction,
    exportAction,
    getInfoAction,
    customerAction,
    groovyAction,
    versionAction,
    textDB,
    textSFTP,
    textBlob,
    getKeyVaultNameList,
    getNameAndWordByKV
}